<script lang="ts">
    import { redirectTo } from '../scripts/router1';
    import { idPageContacts, idPageMentionsLegales } from '../scripts/router2';

</script>

<style lang="scss">
    .footer {
        width: 100%;
        background-color: $color_primary;
        &__title {
            margin: 40px 0 0 2px;
            font-family: 'Borna-SemiBold';
            font-size: 21px;
        }
        &__logos {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            margin: 30px 0 45px 0;
            flex-wrap: wrap;
        }
        &__a {
            width: 30%;
            margin: 0 10px 20px 0;
        }
        &__logo {
            filter: grayscale(1);
            mix-blend-mode: multiply;
            width: 100%;
            &__1 {
                height: 80px;
                width: auto;
            }
            &__2 {
                height: 90px;
            }
            &__8 {
                width: auto;
                height: 50px;
            }
            &__9 {
                width: auto;
                height: 70px;
            }
            &__10 {
                width: auto;
                height: 60px;
            }
            &__11 {
                width: auto;
                height: 42px;
            }
        }
    }

    .navfooter{
        position: relative;
        z-index: 200;
        height: 30px;
        margin: -15px 0 0 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        font-family: 'Borna-Medium';
        &__img {
            height: 26px;
        }
        &__item {
            min-height: 100%;
            margin: 0 0 0 0;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            margin: 0 10px 0 0;
        }
    }

    .ballFooter {
        position: absolute;
        border-radius: 50%;
        mix-blend-mode: multiply;
        z-index: 0;
        margin-top: -241px;
        left: -200px;
        width: 400px;
        height: 400px;
        background-color: $color_secondary;
        clip-path: polygon(60% 0%, 100% 0, 100% 60%, 0 60%, 0 0);
    }

    @include large {
        .footer {
            width: 82%;
            &__title {
                margin: 40px 0 0 4px;
            }
            &__logos {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin: 30px 0 45px 4px;
                flex-wrap: nowrap;
            }

            &__a {
                margin: 0 0 0 0;
                width: auto;
            }
            &__logo {
                height: 40px;
                &__1 {
                    height: 70px;
                }
                &__2 {
                    height: 90px;
                }
                &__3 {
                    height: 42px;
                }
                &__4 {
                    height: 35px;
                }
                &__6 {
                    height: 48px;
                }
                &__7 {
                    height: 23px;
                }
                &__8 {
                    margin-top: -10px;
                }
                &__9 {
                    height: 70px;
                }
                &__10 {
                    height: 50px;
                }
                &__11 {
                    height: 42px;
                }
            }
        }

        .navfooter{
            z-index: 2000;
            justify-content: center;
            position: absolute;
            &__img {
                opacity: 0;
                height: 30px;
            }
            &__item {
                cursor: pointer;
                background-repeat: no-repeat;
                background-size: contain;
                background-position: center;
                margin: 0 15px 0 0;
            }
            &__mentions {
                align-items: inherit;
                background-image: url('../assets/images/btn_mentions_legales.svg');
                &:hover {
                    background-image: url('../assets/images/btn_mentions_legales_hover.svg');
                }
            }
            &__credits {
                background-image: url('../assets/images/btn_credits.svg');
                &:hover {
                    background-image: url('../assets/images/btn_credits_hover.svg');
                }
            }
            &__contacts {
                align-items: inherit;
                background-image: url('../assets/images/btn_contacts.svg');
                &:hover {
                    background-image: url('../assets/images/btn_contacts_hover.svg');
                }
            }
        }
    }

    @include xlarge {
        .footer {
            &__logo {
                height: 60px;
                &__1 {
                    height: 68px;
                }
                &__2 {
                    height: 85px;
                }
                &__3 {
                    height: 72px;
                }
                &__4 {
                    height: 50px;
                }
                &__6{
                    height: 60px
                }
                &__7 {
                    height: 32px;
                }
                &__8 {
                    margin-top: -10px;
                }
                &__9 {
                    height: 70px;
                }
                &__10 {
                    height: 50px;
                }
                &__11 {
                    height: 42px;
                }
            }
        }
    }

</style>

<div class="footer">
    <div id="idBallFooter" class="ballFooter"></div>
    <div class="navfooter">
        <div class="navfooter__item navfooter__mentions" on:click={() => redirectTo(idPageMentionsLegales)} on:keydown={() => redirectTo(idPageMentionsLegales)}>
            <img class="navfooter__img" src="../assets/images/btn_mentions_legales.svg" alt="mentions léglales">
        </div>
        <div class="navfooter__item navfooter__contacts" on:click={() => redirectTo(idPageContacts)} on:keydown={() => redirectTo(idPageContacts)}>
            <img class="navfooter__img" src="../assets/images/btn_contacts.svg" alt="contacts">
        </div>
    </div>
    <div class="footer__title">nos partenaires</div>
    <div class="footer__logos">
        <div class="footer__a">
            <a href="https://lannuaire.service-public.fr/gouvernement/3194da17-868c-4151-9f62-8bfae2ab3585" target="_blank">
                <img class="footer__logo footer__logo__1" src="../assets/images/01_footer_logo.svg" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://www.lelabo-ess.org/" target="_blank">
                <img class="footer__logo footer__logo__3" src="../assets/images/03_footer_logo.jpg" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://www.rtes.fr/" target="_blank">
                <img class="footer__logo footer__logo__4" src="../assets/images/04_footer_logo.jpg" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://www.ess-france.org/" target="_blank">
                <img class="footer__logo footer__logo__5" src="../assets/images/05_footer_logo.jpg" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="http://www.coorace.org/" target="_blank">
                <img class="footer__logo footer__logo__6" src="../assets/images/06_footer_logo.jpg" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://institutgodin.com/" target="_blank">
                <img class="footer__logo footer__logo__7" src="../assets/images/07_footer_logo.jpg" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://www.archer.fr/" target="_blank">
                <img class="footer__logo footer__logo__8" src="../assets/images/08_footer_logo.png" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://www.madynco.fr/" target="_blank">
                <img class="footer__logo footer__logo__9" src="../assets/images/09_footer_logo.png" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://ptcesudaquitaine.coop/" target="_blank">
                <img class="footer__logo footer__logo__10" src="../assets/images/10_footer_logo.png" alt="logo">
            </a>
        </div>
        <div class="footer__a">
            <a href="https://www.coop-ideal.org/ptce-nola-cooperation-pole/" target="_blank">
                <img class="footer__logo footer__logo__11" src="../assets/images/11_footer_logo.jpg" alt="logo">
            </a>
        </div>
    </div>
</div>